export default __webpack_public_path__ + "static/media/footer@2x.bbd9182f.jpg";